import * as React from 'react';

import { mergeStyles } from '@cian/utils/lib/shared/style';

import * as styles from './region_field.css';
import { ISuggestValue, SuggestInput } from '../../suggest_input';
import { IRegion } from '../../../types/region';

interface IRegionFieldProps {
  width?: number;
  className: string;
  regions?: IRegion[];
  region?: IRegion;
  onSelect(value: number): void;
}

const notFoundText = (
  <div>
    <div className={styles['not_found-text-bold']}>Ничего не найдено</div>
    <div className={styles['not_found-text']}>Укажите другой город</div>
  </div>
);

const RegionField = (props: IRegionFieldProps) => {
  let values: ISuggestValue[] = [{ value: 0, label: '' }];

  if (props.regions) {
    values = props.regions.map(r => ({ value: r.id, label: r.displayName }));
  }

  return (
    <div {...mergeStyles(props.className, styles['container'])}>
      <SuggestInput
        width={props.width}
        region={props.region}
        onSelect={props.onSelect}
        suggestions={values}
        valueNotFound={notFoundText}
      />
    </div>
  );
};

export { RegionField };
